import React, { useEffect, useRef, useState } from 'react';

export function Reveal({ children, delay = 0, className = '' }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setShown(true); io.disconnect(); }
    }, { threshold: 0.12 });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <div ref={ref} className={className}
      style={{ opacity: shown ? 1 : 0, transform: shown ? 'none' : 'translateY(26px)', transition: `opacity .7s ease ${delay}ms, transform .7s cubic-bezier(.2,.8,.2,1) ${delay}ms` }}>
      {children}
    </div>
  );
}

export function Eyebrow({ children, color = '#FF204E' }) {
  return (
    <div className="flex items-center gap-2 mb-3">
      <span className="h-px w-8" style={{ background: color }} />
      <span className="text-xs font-600 tracking-[0.28em] uppercase" style={{ color }}>{children}</span>
    </div>
  );
}

export function SectionHeading({ eyebrow, title, sub, color, center }) {
  return (
    <div className={center ? 'text-center max-w-2xl mx-auto' : 'max-w-2xl'}>
      {eyebrow && <div className={center ? 'flex justify-center' : ''}><Eyebrow color={color}>{eyebrow}</Eyebrow></div>}
      <h2 className="font-display font-700 text-3xl md:text-4xl text-white tracking-tight">{title}</h2>
      {sub && <p className="mt-3 text-white/55 leading-relaxed">{sub}</p>}
    </div>
  );
}

export function ComingSoon({ className = '' }) {
  return (
    <span className={`inline-flex items-center gap-1.5 text-[10px] font-600 tracking-[0.18em] uppercase px-2.5 py-1 rounded-full border border-[#B026FF]/40 text-[#B026FF] bg-[#B026FF]/8 ${className}`}>
      Coming Soon
    </span>
  );
}

export function StatusDot({ status }) {
  const map = {
    'Available': '#2FBF71', 'Ready': '#2FBF71', 'Leader': '#E0B85A',
    'Offline': '#5b5b66', 'Casino Only': '#B026FF', 'Do Not Disturb': '#FF204E', 'Member': '#8a8a95',
  };
  return <span className="h-2 w-2 rounded-full inline-block" style={{ background: map[status] || '#8a8a95', boxShadow: `0 0 8px ${map[status] || '#8a8a95'}` }} />;
}

export function difficultyColor(d) {
  return { Low: '#2FBF71', Medium: '#E0B85A', High: '#FF204E', Extreme: '#B026FF' }[d] || '#8a8a95';
}
